import React, { useState } from 'react'
import Overview from './Overview';
import General from './General';

const tabs = [
  'Overview',
  // 'General Settings'
]

const RightView = () => {
  const [tab, setTab] = useState("Overview");
  return (
    <div>
      <ul className='Tabs' >
        {
          tabs.map((page, id) => (
            <li key={id} onClick={()=>setTab(page)} className={tab===page&&"Selected_tab"} >
              {page}
            </li>
          ))
        }
      </ul>
      <div>
        {
          tab === "Overview" ? <Overview /> :
          tab === "General Settings" ? <General />:
          null
        }
      </div>
    </div>
  )
}

export default RightView